import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import {
  Button, Dialog, DialogContent, DialogTitle, SelectField, MenuItem,
  DialogFooter,
} from '../../../../2-component';
import { FormDefinitionSelect } from '../../../../3-pattern/formDefinitionSelect/formDefinitionSelect';
import { WorkflowContext, WorkflowContextType } from '../../workflowCompletion';
import { UserContext } from '../../../../../providers/userContextProvider';

const PREPARE_FORM_COMPLETION = gql`
  mutation prepareFormCompletion($input: PrepareFormCompletionInput!) {
    prepareFormCompletion(input: $input) {
      formCompletion { id }
    }
  }
`;

export const AddNewForm = ({
  workflowCompletionId,
  userId,
  refetch,
}: {
  workflowCompletionId: string;
  userId: string;
  refetch: () => void;
}) => {
  const { t } = useTranslation(['workflowCompletions', 'accountTypes']);
  const [open, setOpen] = useState(false);
  const [formDefinitionKey, setFormDefinitionKey] = useState('');
  const [objectType, setObjectType] = useState('');
  const [objectId, setObjectId] = useState(userId);
  const { workflowData } = useContext(WorkflowContext) as WorkflowContextType;
  const { activeOrganization } = useContext(UserContext);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [prepareFormCompletion, { loading }] = useMutation(PREPARE_FORM_COMPLETION);

  const handlePrepareFormCompletion = async () => {
    await prepareFormCompletion({
      variables: {
        input: {
          workflowCompletionId,
          userId,
          organizationId: activeOrganization?.id,
          formMapping: { formDefinitionKey, objectType, objectId },
        },
      },
    });
    refetch();
    handleClose();
    setFormDefinitionKey('');
    setObjectType('');
    setObjectId(userId);
  };

  return (
    <div>
      <Button onClick={handleOpen} label={t('workflowCompletions:addNewForm')} variant='tonal' size='sm'/>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
        <DialogTitle onClose={handleClose}>{t('workflowCompletions:addNewForm')}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormDefinitionSelect
            label={t('workflowCompletions:formDefinition')}
            value={formDefinitionKey}
            onChange={(e: any) => setFormDefinitionKey(e)}
            onObjectTypeChange={(e: any) => {
              setObjectType(e);
              setObjectId(userId);
            }}
          />
          { objectType === 'ACCOUNT' && (
            <SelectField
              label={t('workflowCompletions:account')}
              value={objectId}
              onChange={(e: any) => setObjectId(e.target.value)}
              fullWidth
            >
              {workflowData.createdAccounts?.filter((account: any) => account.state !== 'ARCHIVED').map((account: any) => (
                <MenuItem key={account.id} value={account.id}>{t(`accountTypes:${account.type}`)}</MenuItem>
              ))}
            </SelectField>
          )}
        </DialogContent>
        <DialogFooter>
          <Button onClick={handlePrepareFormCompletion} label={t('workflowCompletions:prepare')} disabled={loading} />
        </DialogFooter>
      </Dialog>
    </div>
  );
};
